export const getProgressBarColors = (status: string) => {
  const upperStatus = status?.toUpperCase() || "";
  switch (upperStatus) {
    case "LAUNCH":
    case "LAUNCHING":
      return {
        bar: "var(--status-01-background-strong)",
        background: "var(--status-01-background-subtle)",
      };
    case "ACTIVE":
    case "IN_PROGRESS":
      return {
        bar: "var(--status-03-background-strong)",
        background: "var(--status-03-background-subtle)",
      };
    case "DONE":
    case "COMPLETED":
      return {
        bar: "var(--success-background-strong)",
        background: "var(--success-background-subtle)",
      };
    case "CANCELED":
      return {
        bar: "var(--neutral-background-strong)",
        background: "var(--neutral-background-subtle)",
      };
    case "PAUSED":
      return {
        bar: "var(--status-02-background-strong)",
        background: "var(--status-02-background-subtle)",
      };
    default:
      return {
        bar: "var(--status-03-background-strong)",
        background: "var(--status-03-background-subtle)",
      };
  }
};

export const formatDate = (dateString: string) => {
  return dateString.replace(/\//g, ".");
};

export function parseDateTime(dateStr: string, timeStr: string): Date {
  try {
    const [day, month, year] = dateStr.split(".");
    if (!day || !month || !year || !timeStr) {
      return new Date(); // Возвращаем текущую дату в случае некорректных данных
    }
    const dateFormatted = `${year}-${month}-${day}T${timeStr}:00`;
    return new Date(dateFormatted);
  } catch (error) {
    console.error("Error parsing date time:", error, dateStr, timeStr);
    return new Date();
  }
}

export function calculateProgressNew(startDate: Date, endDate: Date): number {
  try {
    const now = new Date();
    let progress = 0;

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return 0; // Возвращаем 0 для некорректных дат
    }

    if (now < startDate) {
      progress = 0;
    } else if (now > endDate) {
      progress = 100;
    } else {
      const totalDuration = endDate.getTime() - startDate.getTime();
      if (totalDuration <= 0) {
        return 100; // Если endDate <= startDate, считаем задачу выполненной
      }
      const elapsedTime = now.getTime() - startDate.getTime();
      progress = (elapsedTime / totalDuration) * 100;
    }

    return Math.min(Math.max(Math.round(progress), 0), 100);
  } catch (error) {
    console.error("Error calculating progress:", error);
    return 0;
  }
}
